/** Active Sync Plus SKU slug — offered in US/CA. */
export const ACTIVE_SYNC_PLUS_ID = 'as_plus';

/** Active Sync Basic SKU slug — offered in US/CA/GB/AU/IE. */
export const ACTIVE_SYNC_BASIC_ID = 'as_basic';

/**
 * The SKU slugs Active Sync ships under in the publisher and estimate lists. The
 * backend sends one per campaign based on the location's country, so consumers
 * match the whole set — matching only `as_plus` left GB/AU/IE campaigns without
 * a price.
 */
export const ACTIVE_SYNC_PRICE_IDS = [ACTIVE_SYNC_PLUS_ID, ACTIVE_SYNC_BASIC_ID] as const;

/** One of the Active Sync SKU slugs. */
export type ActiveSyncPriceId = (typeof ACTIVE_SYNC_PRICE_IDS)[number];

/** True when a publisher or estimate entry id is an Active Sync SKU. */
export const isActiveSyncId = (id: string) => ACTIVE_SYNC_PRICE_IDS.some((priceId) => priceId === id);
